import { html, LitElement } from 'lit-element'

import { getExternalInterface } from '../../services/external-interface'

export class ShellLandingController extends LitElement {
  static readonly tagName = 'goto-shell-landing-controller'

  render() {
    if (getExternalInterface().isIntegration) {
      return html`<goto-integration-disconnected-page></goto-integration-disconnected-page>`
    }

    return html`<goto-shell-landing></goto-shell-landing>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [ShellLandingController.tagName]: ShellLandingController
  }
}
